import * as React from 'react';
type Props = {
  className?: string;
};
export function Tempeh({ className }: Props) {
  return (
    <svg
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-Tempeh"
      className={className}
    >
      <path
        d="M16.0809 22.3843C16.0809 22.3843 12.0802 21.6817 9.56987 19.0101M12.5266 26.1713C12.5266 26.1713 8.52452 25.4686 6.01488 22.7971M27.8634 13.3236C27.8634 13.3236 30.7418 12.8993 32.5481 11.2868M30.5404 16.0392C30.5404 16.0392 33.4194 15.6149 35.225 14.0025M10.6273 30.5245C6.67542 32.993 4.59276 29.9698 2.68276 26.6961C-0.582445 21.1005 3.00801 18.4772 7.94095 16.1662C15.5769 12.5863 17.242 14.6006 20.0568 19.3781C22.4199 23.3905 18.5838 25.4972 16.8445 26.6221C14.5831 28.0831 12.647 29.2638 10.6273 30.5245ZM32.2175 19.5017C34.9473 21.1698 36.3855 19.1276 37.7052 16.9164C39.9605 13.1369 37.4804 11.3649 34.0726 9.80341C28.7984 7.3858 27.6479 8.74634 25.7031 11.9732C24.0709 14.6828 26.7204 16.1064 27.9223 16.8655C29.4843 17.8533 30.8221 18.6503 32.2175 19.5017Z"
        stroke="currentColor"
        strokeWidth={0.93693}
      />
    </svg>
  );
}
